import { render, staticRenderFns } from "./GroupManagementTable.vue?vue&type=template&id=ef09943a&"
import script from "./GroupManagementTable.vue?vue&type=script&lang=js&"
export * from "./GroupManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagementTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports